<div class="flex flex-column">
    <div class="text-xl font-medium mb-2">Vérification en deux étapes</div>
    <p class="text-color-secondary text-sm mb-5">
        Ouvrez votre application d'authentification et saisissez le code à 6 chiffres.
    </p>

    <div class="flex align-items-center justify-content-center w-full">
        <form [formGroup]="form"  [pAutoFocus]="true" novalidate class="flex flex-column gap-4 w-17rem">
            <div class="flex justify-content-center">
                <p-inputotp formControlName="code" [length]="6" [integerOnly]="true"></p-inputotp>
            </div>
        </form>
    </div>
</div>